import { checkPropTypes, oneOfType, string, number, func, shape, instanceOf } from 'prop-types';

export const stringOrNumberPropTypes = oneOfType([string, number]);

export const anyKeyPropTypes = shapeObj => (props, propName, componentName) => {
  const propValue = props[propName];
  const keys = Object.keys(propValue);

  if (keys) {
    keys.forEach(key => {
      checkPropTypes({ [key]: shapeObj }, { [key]: propValue[key] }, propName, componentName);
    });
  }
};

export const refPropTypes = oneOfType([func, shape({ current: instanceOf(Element) })]);
